import { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { MagnifyingGlass, CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";

const CHECKS = {
  tin: { label: "TIN", fields: [["number", "Tax ID number"]], run: (v) => api.post("/mono/lookup/tin", { number: v.number }) },
  cac: { label: "CAC business", fields: [["search", "Business name or RC number"]], run: (v) => api.get("/mono/lookup/cac", { params: { search: v.search } }) },
  address: { label: "Address", fields: [["address", "Address"], ["meter_number", "Electricity meter number"]], run: (v) => api.post("/mono/lookup/address", v) },
};

/** Extra identity checks for reviewers, powered by Mono Lookup (separate product and keys from Prove). */
export default function MonoLookupPanel() {
  const [kind, setKind] = useState("tin");
  const [vals, setVals] = useState({});
  const [busy, setBusy] = useState(false);
  const [out, setOut] = useState(null);
  const c = CHECKS[kind];
  const run = async () => {
    setBusy(true);
    try { const { data } = await c.run(vals); setOut(data); }
    catch (e) { toast.error(formatErr(e?.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };
  return (
    <div className="card" data-testid="mono-lookup-panel">
      <div className="flex items-center gap-2 mb-3 text-[#0A3622]"><MagnifyingGlass size={18} weight="bold" /><h2 className="font-display text-lg font-medium">Extra checks (Mono Lookup)</h2></div>
      <div className="flex flex-wrap gap-2 mb-3">
        {Object.entries(CHECKS).map(([k, v]) => (
          <button key={k} onClick={() => { setKind(k); setVals({}); setOut(null); }} className={`btn-ghost text-xs ${kind === k ? "!bg-[#0A3622] !text-white" : ""}`} data-testid={`lookup-tab-${k}`}>{v.label}</button>
        ))}
      </div>
      <div className="grid gap-2">
        {c.fields.map(([f, label]) => (
          <input key={f} className="input text-sm" placeholder={label} value={vals[f] || ""} onChange={(e) => setVals({ ...vals, [f]: e.target.value })} data-testid={`lookup-${kind}-${f}`} />
        ))}
        <button onClick={run} disabled={busy || c.fields.some(([f]) => !(vals[f] || "").trim())} className="btn-outline !py-2 text-sm justify-center disabled:opacity-50" data-testid="lookup-run">
          {busy ? <CircleNotch size={14} className="animate-spin" /> : `Run ${c.label} lookup`}
        </button>
      </div>
      {out && (
        <pre className="mt-3 text-[11px] bg-[#F9F7F4] border border-[#E5E3DB] rounded-xl p-3 overflow-auto max-h-56" data-testid="lookup-result">
          {out.sample ? "Sample result — add MONO_LOOKUP_SECRET_KEY to run real lookups.\n" : ""}{JSON.stringify(out.result, null, 2)}
        </pre>
      )}
    </div>
  );
}
